document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById("country_select");
  const contents = document.querySelectorAll(".country-content");

  if (!select || !contents.length) return;

  // Oculta todo al cargar
  contents.forEach((el) => (el.style.display = "none"));

  select.addEventListener("change", () => {
    const value = select.value;

    // Oculta todo
    contents.forEach((el) => (el.style.display = "none"));
    if (!value) return;

    // Busca si hay contenido en el país
    let found = false;
    contents.forEach((el) => {
      if (el.dataset.country === value) {
        el.style.display = "block";
        found = true;
      }
    });

    // Si no hay contenido en el país, muestra el default (Todos los países)
    if (!found) {
      const fallback = document.querySelector('.country-content[data-country="__default__"]');
      if (fallback) fallback.style.display = "block";
    }
  });
});

document.querySelectorAll(".shipping-collapsible__btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    const content = btn.nextElementSibling;
    const isOpen = btn.getAttribute("aria-expanded") === "true";

    btn.setAttribute("aria-expanded", String(!isOpen));
    content.hidden = isOpen;

    const icon = btn.querySelector(".shipping-collapsible__icon");
    if (icon) icon.textContent = isOpen ? "+" : "–";
  });
});